import { AbstractControl, ValidatorFn } from '@angular/forms';

import { PHONENUMBER } from '../validators.expressions';

/*
 * No params required.
 * Takes a formControlName that would be of type string and matches to RegExp.
 * Usage:
 *    import { mlpPhoneNumberValidator } from './validators.phone.number';
 *
 * Example:
 *     this.form = this.fb.group({
 *          phone: ['', [mlpPhoneNumberValidator()]]
 *     });
*/

export function mlpPhoneNumberValidator(): ValidatorFn {

    return (control: AbstractControl): {[key: string]: any} => {
        let isValid = false;
        const data = control.value;

        if (data && data.match(PHONENUMBER)) {
            isValid = true;
        }

        return isValid ? undefined : { invalidPhoneNumber: { value: data }} ;
    };
}
